import React from 'react';
import { IconButton, CircularProgress } from '@material-ui/core/';
import { PauseCircleFilled, PlayCircleFilled } from '@material-ui/icons/';

const PlayPauseButton = ({ player, status }) => {
  const togglePlayPause = (e) => {
    if (status === 'playing') {
      player.pause();
    } else if (status === 'paused') {
      player.play();
    }
    e.stopPropagation();
  };

  const showPlayPause = () => {
    if (status === 'playing') {
      return <PauseCircleFilled style={{ fontSize: '4em' }} color="primary" />;
    } else if (status === 'paused' || status === 'loaded') {
      return <PlayCircleFilled style={{ fontSize: '4em' }} color="primary" />;
    } else if (status === 'loading') {
      return <CircularProgress />;
    }
  };

  return (
    <IconButton
      size="small"
      color="primary"
      onClick={togglePlayPause}
      disableFocusRipple={true}
      disableRipple={true}
    >
      {showPlayPause()}
    </IconButton>
  );
};

export default PlayPauseButton;
